
/**
 * ua.schema.editor.v2
 * Adds support for 'list' (array) fields using block card-style UI.
 * Extends object navigation and introduces item-based editing, insertion, and removal.
 */

var _ = require("../../../uam/module.js")(module.exports, {
  namespace: "ua.schema.editor",
  title: "Schema Editor (v2)",
  description: "Multilayer schema editor with array support via block cards.",
  editable: true,
  control: true,
  fields: {
    schema: {
      title: "Schema",
      type: "object",
      description: "Full field schema definition.",
      required: true
    },
    data: {
      title: "Data",
      type: "object",
      description: "Initial data to load."
    },
    path: {
      title: "Path",
      type: "list",
      of: "string",
      description: "Navigation path (internal)."
    }
  }
});

var jsonRender = require("../interface/jsonRender.js");

function getAtPath(obj, path) {
  return path.reduce((acc, key) => acc && acc[key], obj);
}

function setAtPath(obj, path, value) {
  let cur = obj;
  for (let i = 0; i < path.length - 1; i++) {
    if (!(path[i] in cur)) cur[path[i]] = {};
    cur = cur[path[i]];
  }
  cur[path[path.length - 1]] = value;
}

exports.render = async function (options) {
  const schema = options.schema || {};
  const data = options.data || {};
  const path = options.path || [];

  const container = {
    n: "div",
    c: "schema-editor",
    i: []
  };

  const currentSchema = getAtPath(schema, path);
  const currentData = getAtPath(data, path) || {};

  if (path.length > 0) {
    container.i.push({
      n: "button",
      c: "btn btn-link mb-2",
      i: "← Back",
      on: {
        click: async () => {
          setTimeout(() => {
            window.UATools.PerformResponse({
              n: "ua.schema.editor",
              schema,
              data,
              path: path.slice(0, -1)
            });
          }, 0);
        }
      }
    });
  }

  for (const key in currentSchema) {
    const fieldSpec = currentSchema[key];
    const value = currentData[key];
    const useNS = (fieldSpec.use && fieldSpec.use.namespace) || "ua.input";
    const conformFn = jsonRender.registry?.[useNS]?.conformField;
    const conformed = conformFn ? conformFn(fieldSpec) : fieldSpec;

    // Handle nested object
    if (fieldSpec.type === "object" && fieldSpec.fields) {
      container.i.push({
        n: "button",
        c: "btn btn-secondary mb-2",
        i: "Edit " + (fieldSpec.title || key),
        on: {
          click: () => {
            setTimeout(() => {
              window.UATools.PerformResponse({
                n: "ua.schema.editor",
                schema,
                data,
                path: [...path, key]
              });
            }, 0);
          }
        }
      });
      continue;
    }

    // Handle array/list
    if ((fieldSpec.type === "list" || fieldSpec.type === "array") && fieldSpec.of) {
      const items = Array.isArray(value) ? value : [];
      const blockList = {
        n: "div",
        c: "list-blocks mb-3",
        i: []
      };

      items.forEach((item, index) => {
        const block = {
          n: "div",
          c: "card p-3 mb-2",
          i: [
            {
              n: "div",
              c: "d-flex justify-content-between align-items-center mb-2",
              i: [
                { n: "strong", i: (fieldSpec.title || key) + " #" + (index + 1) },
                {
                  n: "button",
                  c: "btn btn-sm btn-danger",
                  i: "Remove",
                  on: {
                    click: () => {
                      items.splice(index, 1);
                      setAtPath(data, [...path, key], items);
                      window.UATools.PerformResponse({
                        n: "ua.schema.editor",
                        schema,
                        data,
                        path
                      });
                    }
                  }
                }
              ]
            },
            {
              n: "ua.schema.editor",
              schema: { item: fieldSpec.of === "object" ? fieldSpec.fields : { value: { type: fieldSpec.of } } },
              data: { item },
              path: [...path, key, index.toString()]
            }
          ]
        };
        blockList.i.push(block);
      });

      // Add item button
      blockList.i.push({
        n: "button",
        c: "btn btn-outline-primary",
        i: "Add New",
        on: {
          click: () => {
            items.push(fieldSpec.of === "object" ? {} : "");
            setAtPath(data, [...path, key], items);
            window.UATools.PerformResponse({
              n: "ua.schema.editor",
              schema,
              data,
              path
            });
          }
        }
      });

      container.i.push(blockList);
      continue;
    }

    // Normal field
    container.i.push({
      n: useNS,
      name: key,
      label: fieldSpec.title || key,
      value: value,
      required: !!fieldSpec.required,
      ...conformed
    });
  }

  // Save button
  container.i.push({
    n: "button",
    c: "btn btn-primary mt-3",
    i: "Save Document",
    on: {
      click: async function () {
        const result = await window.UATools.save();
        if (result.success) {
          console.log("Saved UA/JSON:", result);
        } else {
          console.error("Validation failed:", result.errors);
        }
      }
    }
  });

  return container;
};

exports.load = async function (name, el, data) {
  await window.UATools.load(name, el, data);
};

exports.save = async function (name, el, pre) {
  return {
    success: true,
    namespace: exports.define.namespace,
    data: pre.data
  };
};
